import React from 'react';
import { observer } from 'mobx-react';
import { HelpCenterWrapper } from '@seedlang/hoc';
import styled from '@emotion/styled';
import { AppUI } from '@seedlang/state';
import Text from 'components/text';
import FaqHeader, { FaqContentWrapper } from 'components/faq_header';
import FaqRow, { FaqRowGrid } from 'components/faq_row';
import { JapaneseCharacterIcon, ClipboardIcon, SeedlangOutlineBoldIcon, PencilWithCircleIcon, TreeIcon, BookmarkIcon, QuestionIcon, SearchWordsIcon } from '@seedlang/icons';
import Spinner from 'components/spinner';
import { sortBy } from 'lodash';
import Fa from 'components/fa';
import Button from 'components/button/button';
import Link from 'components/link';
import CreatorContactUs from 'pages/creator/creator_contact_us';

const EmptyMessage = styled.div`
  background: white;
  border-radius: 5px;
  padding: 30px;
  text-align: center;
`;

const ContactLinkWrapper = styled.div`
  margin-top: 40px;
  font-size: 14px;
  text-align: center;
`;

@observer
class HelpCenter extends React.Component {

  icon = (faqCategory) => {
    if (AppUI.siteIsMemrev) {
      return faqCategory.icon ? <Fa i={faqCategory.icon} style={{ fontSize: '22px' }} /> : null;
    }
    const ICONS = {
      grammar: <PencilWithCircleIcon />,
      general: <ClipboardIcon />,
      reviews: <BookmarkIcon />,
      stories: <TreeIcon />,
      trivia: <QuestionIcon />,
      membership: <SeedlangOutlineBoldIcon />,
      translator: <JapaneseCharacterIcon />,
      vocab: <SearchWordsIcon />,
    };
    return ICONS[faqCategory.slug] || <TreeIcon />;
  }

  render() {
    const faqCategories = sortBy(this.props.faqCategories.filter(item => item.published || AppUI.user.admin), ['position']);
    const showContactUs = AppUI.siteIsMemrev && AppUI.user?.isAdminForSite(AppUI.site?.id);

    return (
      <FaqContentWrapper>
        <FaqHeader
          currentRoute='help_center'
          margin='0 0 10px 0'
        />
        {
          this.props.showSpinner &&
          <Spinner />
        }
        {
          !this.props.showSpinner && this.props.loadFailed &&
          <EmptyMessage>
            <Text
              fontSize='16px'
              lineHeight='22px'
              color='#333'
              margin='0 0 15px 0'
            >
              Sorry, we couldn&apos;t load the help articles.
            </Text>
            <Button onClick={this.props.retryLoad}>
              Try Again
            </Button>
          </EmptyMessage>
        }
        {
          !this.props.showSpinner && !this.props.loadFailed && faqCategories.length === 0 &&
          <EmptyMessage>
            <Text
              fontSize='16px'
              lineHeight='22px'
              color='#333'
            >
              There aren't any help articles yet.
            </Text>
          </EmptyMessage>
        }
        {
          !this.props.loadFailed &&
          <FaqRowGrid>
            {
              faqCategories.map(faqCategory => (
              <FaqRow
                key={faqCategory.id}
                to={{ name: 'faq_categories.show', params: { faqCategoryId: faqCategory.id } }}
                icon={this.icon(faqCategory)}
                iconBackground={faqCategory.color || AppUI.site.accentColor}
                iconColor='#FFF'
                title={faqCategory.published ? faqCategory.name : `${faqCategory.name} [Unpublished]`}
                description={faqCategory.description}
                mutedText={`${faqCategory.faqItemsCount || 0} Article${faqCategory.faqItemsCount === 1 ? '' : 's'}`}
              />
              ))
            }
          </FaqRowGrid>
        }
        {
          AppUI.siteIsMemrev && !this.props.loadFailed &&
          <ContactLinkWrapper>
            <Link to='contact' className='underline'>Contact Us</Link>
          </ContactLinkWrapper>
        }
        {showContactUs && <CreatorContactUs showAdminsOnlyInfo />}
      </FaqContentWrapper>
    );
  }
}

export default HelpCenterWrapper(HelpCenter);
